import { useMemo, useRef } from "react";
import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";
import { useSelector } from "react-redux";

const ApolloWrapper = ({ children }) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const authTokenValue = useSelector(
    (state) => state.authReducer.user.authToken
  );
  const ImpersonationId = useSelector(
    (state) => state.authReducer.impersonationId
  );

  const tokenRef = useRef(authTokenValue);
  const impersonationRef = useRef(ImpersonationId);
  const emailRef = useRef(null);

  tokenRef.current = authTokenValue;
  impersonationRef.current = ImpersonationId;

  const profile = JSON.parse(localStorage.getItem("userProfile"));
  emailRef.current = profile?.EmailAddress ?? null;

  const client = useMemo(() => {
    const httpLink = new HttpLink({
      uri: `${BackendApiBaseUrl}/query`,
    });

    const authLink = setContext((_, { headers }) => {
      const token = tokenRef.current;
      const impersonation = impersonationRef.current;
      const email = emailRef.current;

      if (impersonation) {
        return {
          headers: {
            ...headers,
            authorization: token ? `${token}` : "",
            email: email,
            impersonationid: impersonation,
          },
        };
      }
      return {
        headers: {
          ...headers,
          authorization: token ? `${token}` : "",
          email: email,
        },
      };
    });

    return new ApolloClient({
      cache: new InMemoryCache(),
      link: authLink.concat(httpLink),
    });
  }, [BackendApiBaseUrl]);

  return (
    <ApolloProvider client={client}>
      {children}
    </ApolloProvider>
  );
};

export { ApolloWrapper };
